import { Moment } from 'moment';

export class FreshItemActionLine {
    constructor(
        public readonly id: string,
        public readonly orderDate: string,
        //public readonly orderDate: Moment,
        public readonly arrivalDate: string,
        //public readonly arrivalDate: Moment,
        public readonly nextArrivalDate: string,
        //public readonly nextArrivalDate: Moment,
        public readonly buffer: number,
        public readonly actionBuffer: number,
        public readonly balance: number,
        public readonly inTransit: number,
        public readonly order: number,
        public readonly actionOrder: number) {
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/fresh-item-action-line.ts